import {
  formatDateToDDMMYYYY,
  formatDateToDDMMYYYYWithOutHyphen,
} from "@/utility/common";
import { Trans } from "react-i18next";
const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function dateFuncOld(date: any) {
  if (!date) {
    return {
      formattedDateTime: "-",
      formattedDateOnly: "-",
    };
  }

  var dateObject = new Date(date);

  // Extract the parts of the date
  var day = ("0" + dateObject.getDate()).slice(-2); // Add leading zero if necessary
  var month = ("0" + (dateObject.getMonth() + 1)).slice(-2); // Add leading zero if necessary, month is 0-indexed
  var year = dateObject.getFullYear().toString().slice(-2); // Get last two digits of year

  // Extract the parts of the time
  var hours = dateObject.getHours();
  var minutes = ("0" + dateObject.getMinutes()).slice(-2); // Add leading zero if necessary
  //var seconds = ("0" + dateObject.getSeconds()).slice(-2); // Add leading zero if necessary
  var ampm = hours >= 12 ? "pm" : "am";
  // Convert 24-hour time to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  // hours = ("0" + hours).slice(-2); // Add leading zero if necessary

  // Combine the parts into the desired format
  var formattedDate = day + "-" + month + "-" + year;
  var formattedTime = hours + ":" + minutes + ampm;
  var formattedTimeWithSemiColon =
    hours.toString().padStart(2, "0") + minutes + ampm;

  return {
    formattedDateTimeWithOutHyphen:
      formatDateToDDMMYYYYWithOutHyphen(formattedDate) +
      " " +
      formattedTimeWithSemiColon,
    formattedDateTime:
      formatDateToDDMMYYYY(formattedDate) + ", " + formattedTime,
    formattedDateOnly: formatDateToDDMMYYYY(formattedDate),
  };
}

export const formatDate = (
  dateString: Date | string,
  format = "DD-MM-YYYY"
) => {
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const day = date.getUTCDate().toString().padStart(2, "0");

  if (format === "YYYY-MM-DD") {
    return `${year}-${month}-${day}`;
  }
  return `${day}-${month}-${year}`;
};
export function useTrans(
  translationFun: any,
  translationKey: string,
  i18nKey: string
) {
  return (
    <Trans t={translationFun} i18nKey={i18nKey}>
      {translationKey}
    </Trans>
  );
}
export function dateFunc(date: Date | string | null | undefined, caseZone?: string) {
  if (!date || date === "") {
    return {
      formattedDateTime: "-",
      formattedDateOnly: "-",
    };
  }

  if (typeof date === "string" && date.length <= 10) {
    date = new Date(`${date} `); // to force the date to be in the local time zone
  }

  const dateObject = new Date(date);
  const formattedDateTime = new Intl.DateTimeFormat("en-CA", {
    dateStyle: "medium",
    timeStyle: "short",
    // already defaults to load string to the local time zone as is
  }).format(dateObject);
  // returns 2025-01-13T12:00:00 => 2025-01-13, 12:00 PM

  //AEST time zone format is not supported by Intl.DateTimeFormat so we are using Australia/Queensland which observes Australian Eastern Standard Time all year.
  const formattedTimeWithSemiColon = new Intl.DateTimeFormat("sv-SE", {
    timeStyle: "medium",
    timeZone: caseZone
      ? caseZone === "AEST"
        ? "Australia/Queensland"
        : caseZone
      : "PST",
  })
    .format(dateObject)
    .replaceAll(":", "");
  // returns 19:10
  const ddmmyyyy = new Intl.DateTimeFormat("en-GB", {
    timeZone: caseZone
      ? caseZone === "AEST"
        ? "Australia/Queensland"
        : caseZone
      : "PST",
  }).format(dateObject);
  const fileFormateDate = ddmmyyyy?.split("/")?.reverse()?.join("") || ddmmyyyy.replaceAll("/", "");
  // returns: 13/01/2025 (DD/MM/YYYY)

  let dateString: any = formattedDateTime.substring(
    0,
    dateObject?.getDate() > 9 ? 12 : 11
  );
  dateString = new Date(dateString);
  dateString = `${dateString?.getDate()?.toString()?.padStart(2, "0")}-${
    monthNames[dateString.getMonth()]
  }-${dateString.getFullYear()}`;
  let timeValue = formattedDateTime.substring(
    formattedDateTime.length,
    formattedDateTime.length - 10
  );
  timeValue = timeValue.includes("a.m.")
    ? timeValue.replace("a.m.", "am")
    : timeValue.replace("p.m.", "pm");
  return {
    date: dateObject,
    formattedDateTimeWithOutHyphen:
    fileFormateDate + " " + formattedTimeWithSemiColon,
    formattedDateTime: `${dateString}, ${timeValue.trimStart()}`,
    formattedDateOnly: dateString,
  };
}
